import {Component} from "../interface/component";
require('slick-carousel/slick/slick.min');

export class CarouselMultipleItemsComponent implements Component {

    private $root:JQuery;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
    }

    init() {
        let dots = true;
        if (this.$root.children().length <= 3){
            dots = false;
        }
        this.$root.slick({
            dots: dots,
            arrows: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            speed: 500,
            fade: false,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }
}
